export enum BookingTypeEnum {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
}
